export default __webpack_public_path__ + "static/media/visa.dd82d62f.svg";